import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ProgressiveBarService {


  readonly NUM_OF_STEPS: number = 11;

  private renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public setProgressiveBarLengthByPageIndex(pageIndex){
    let element = document.getElementById('progressIndicator') as HTMLElement;

    if (element){
      let percentage = pageIndex * 100/this.NUM_OF_STEPS;
      this.renderer.setStyle(element, "width", percentage+"%");

      if(pageIndex >= this.NUM_OF_STEPS ){
        this.renderer.setStyle(element, "background-color", "#30e39d");
        this.renderer.setStyle(element, "border-radius", "0 0 0 0");
      }else{
        this.renderer.setStyle(element, "background-color", "#5A85F0");
        this.renderer.setStyle(element, "border-radius", "0 0 0 0");
      }
    }
  }

}
